import React from 'react'
import { Helmet } from 'react-helmet-async'
import { Link } from 'react-router-dom'

export default function ErrorPage() {
  return (
    <>
      <Helmet>
        <title>404 - Oldal nem található | BeArt Művészetterápia</title>
        <meta name="description" content="A keresett oldal nem található" />
      </Helmet>
      
      <div className="container mx-auto px-4 py-8 text-center">
        <h1 className="text-6xl font-bold text-gray-800 mb-4">404</h1>
        <h2 className="text-2xl font-semibold text-gray-600 mb-4">Oldal nem található</h2>
        <p className="text-gray-500 mb-8">A keresett oldal nem létezik vagy áthelyezésre került.</p>
        <Link 
          to="/" 
          className="bg-amber-400 hover:bg-amber-500 text-white font-bold py-2 px-4 rounded transition-colors"
        >
          Vissza a főoldalra
        </Link>
      </div>
    </>
  )
}
